"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    toggleVariants: ()=>toggleVariants,
    toggleSizes: ()=>toggleSizes,
    toggleEmphases: ()=>toggleEmphases,
    toggleEmphasisVariants: ()=>toggleEmphasisVariants
});
const tv_cjs_namespaceObject = require("../../variants/tv.cjs");
const sizeVariants = {
    20: {
        root: [
            'h-5 w-9 rounded-[calc(0.25rem*9)]',
            'after:-left-1 after:-top-3 after:w-11 after:h-11 hover:drop-shadow-md'
        ],
        tapSpaceSlot: '-left-1 -top-3 w-12 h-11',
        slider: 'inset-[2px] h-4 w-4 data-checked:translate-x-4'
    },
    24: {
        root: [
            'h-6 w-11 rounded-[calc(0.25rem*11)]',
            'after:-left-1 after:-top-3 after:w-13 after:h-12'
        ],
        tapSpaceSlot: '-left-1 -top-3 w-13 h-12',
        slider: 'inset-[2px] h-5 w-5 data-checked:translate-x-5'
    },
    32: {
        root: 'h-8 w-14 rounded-[calc(0.25rem*14)] ',
        slider: 'inset-1 h-6 w-6 data-checked:translate-x-6'
    }
};
const toggleSizes = Object.keys(sizeVariants);
const toggleEmphasisVariants = {
    regular: {
        root: `
      bg-primary-5
      hover:bg-primary-6
      focus-visible:outline-primary-8
      data-checked:bg-primary-8
      hover:data-checked:bg-primary-9
      data-disabled:bg-primary-2
      hover:data-disabled:bg-primary-2
    `,
        slider: `    
      bg-primary-1
      data-disabled:bg-primary-6
    `
    },
    medium: {
        root: `    
      bg-primary-5
      hover:bg-primary-6
      focus-visible:outline-primary-8
      data-checked:bg-primary-8
      hover:data-checked:bg-primary-9
      data-disabled:bg-primary-1/60
      hover:data-disabled:bg-primary-1/60
    `,
        slider: `     
      bg-primary-1
      data-disabled:bg-primary-6
    `
    },
    bold: {
        root: `    
      bg-primary-1/40      
      hover:bg-primary-1/40
      focus-visible:outline-primary-1
      data-checked:bg-primary-8
      hover:data-checked:bg-primary-9
      data-disabled:bg-primary-1/20
      hover:data-disabled:bg-primary-1/20      
    `,
        slider: `     
      bg-primary-1
      data-disabled:bg-primary-1/40
   `
    }
};
const toggleEmphases = Object.keys(toggleEmphasisVariants);
const toggleVariants = (0, tv_cjs_namespaceObject.tv)({
    slots: {
        root: 'data-checked:duration-extra-short data-checked:ease-out data-unchecked:duration-snap data-unchecked:ease-in group relative flex cursor-pointer transition focus-visible:outline-2 focus-visible:outline-offset-2 disabled:cursor-not-allowed',
        tapSpaceSlot: 'absolute bg-transparent opacity-0',
        slider: 'data-disabled:shadow-none data-checked:transition absolute flex items-center justify-center rounded-full shadow-sm transition duration-300 group-hover:shadow-lg'
    },
    variants: {
        size: sizeVariants,
        emphasis: toggleEmphasisVariants
    },
    compoundVariants: [],
    defaultVariants: {
        emphasis: 'regular',
        size: '24'
    }
});
exports.toggleEmphases = __webpack_exports__.toggleEmphases;
exports.toggleEmphasisVariants = __webpack_exports__.toggleEmphasisVariants;
exports.toggleSizes = __webpack_exports__.toggleSizes;
exports.toggleVariants = __webpack_exports__.toggleVariants;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "toggleEmphases",
    "toggleEmphasisVariants",
    "toggleSizes",
    "toggleVariants"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
